<app-shared-modal-filters-advanced
  [buttonCloseCross]="buttonCloseCross"
  [colDefsIgnore]="colDefsIgnore"
  [colDefs]="colDefs"
  [gridReference]="gridReference"
  [isAdvancedFiltersLoading]="(isAdvancedFilterGroupsLoading$ | ngrxPush)"
  [lockCategoryTabs]="lockCategoryTabs"
  [modalTitle]="modalTitle"
  [setAdvancedFilterGroups]="(advancedFilterGroups$ | ngrxPush)"
  [setAppliedFilter]="(appliedAdvancedFilterGroup$ |ngrxPush)"
  [setSelectedAdvancedFilterGroup]="(selectedAdvancedFilterGroup$ | ngrxPush)"
  [setSelectedFilters]="(selectedStoreFilters$ | ngrxPush)">
</app-shared-modal-filters-advanced>
